<div
  style="background-color: #f6f6f4 !important; height: 100vh"
  class="full-screen-bg flex flex-column align-items-center justify-content-center"
>
  <div
    style="width: 480px"
    class="surface-card border-round-lg px-5 py-5 border-1 border-100"
  >
    <form
      class="login100-form"
      [formGroup]="formGroup"
      (ngSubmit)="login()"
      autocomplete="off"
    >
      <div class="mb-5 flex justify-content-between">
        <img
          *ngIf="$companyInfo()"
          style="width: 40%; object-fit: contain; max-height: 100px"
          alt="{{ $companyInfo().company_name }}"
          src="{{ displayImage($companyInfo().logo_file) }}"
          loading="eager|lazy"
          (error)="onImageError($event)"
        />
        <p-divider *ngIf="logoUrl" layout="vertical" />
        <img
          *ngIf="logoUrl"
          style="width: 40%; object-fit: contain; max-height: 100px"
          src="{{ logoUrl }}"
          alt="Logo"
          class="logo"
        />
      </div>

      <div class="flex flex-column">
        <p-iconField iconPosition="right">
          <p-inputIcon styleClass="pi pi-user text-lg pr-2" />
          <input
            pInputText
            type="text"
            placeholder="Email"
            class="w-full mb-3 border-round border-1 border-100 p-3 text-900"
            formControlName="username"
          />
        </p-iconField>

        <p-iconField iconPosition="right">
          <a class="pointer" *ngIf="!showPass" (click)="showPass = !showPass"
            ><p-inputIcon styleClass="pi pi-eye cursor-pointer text-lg pr-2" />
          </a>

          <a class="pointer" *ngIf="showPass" (click)="showPass = !showPass">
            <p-inputIcon
              styleClass="pi pi-eye-slash cursor-pointer text-lg pr-2"
            />
          </a>
          <input
            pInputText
            type="{{ !showPass ? 'password' : 'text' }}"
            placeholder="Password"
            class="w-full border-round border-1 border-100 p-3 text-900"
            formControlName="password"
            (keyup.enter)="login()"
          />
        </p-iconField>
        <span
          class="text-lg underline font-italic cursor-pointer text-gray-600 mt-3 hover:text-900"
          (click)="forgotPassword()"
          style="cursor: pointer; width: fit-content"
          >Forgot Password?</span
        >
        <div class="text-center">
          <!-- [disabled]="formGroup.invalid" -->
          <p-button
            label="Log in"
            [rounded]="true"
            styleClass="mt-5 hover:surface-900 hover:border-900 text-xl "
            [style]="{ width: '40%', 'border-radius': '30px' }"
            (click)="login()"
          ></p-button>
        </div>
        <div class="text-center mt-3 text-lg">
          <span class="text-600">Don't have an account?</span>
          <a
            class="ml-2 underline font-italic cursor-pointer text-gray-600 hover:text-900"
            (click)="openSignUp()"
            >Sign up now
          </a>
        </div>
      </div>
    </form>
  </div>
  <div class="text-center text-xl mt-4">
    © {{ year }} {{ siteConfig?.system?.name ?? '' }}. All rights reserved.
  </div>
</div>

<p-dialog
  [draggable]="false"
  [modal]="true"
  [(visible)]="popupForgetPassword"
  [closable]="!isResettingPassword"
  [closeOnEscape]="!isResettingPassword"
  [style]="{ width: '500px', maxWidth: 'calc(100vw - 2rem)' }"
  styleClass="signup-dialog"
  (onHide)="onForgetPasswordHide()"
>
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-3">
      <div>
        <h2 class="text-2xl font-bold text-900 m-0 line-height-2">
          Forgot Password?
        </h2>
        <p class="text-lg text-500 m-0 mt-1">
          Enter your email to receive a password reset link
        </p>
      </div>
    </div>
  </ng-template>

  <form
    class="flex flex-column gap-3 pt-2"
    [formGroup]="forgetEmailFormGroup"
    (ngSubmit)="resetPassword()"
    autocomplete="off"
  >
    <div class="flex flex-column gap-2">
      <label for="forget-email" class="signup-label">
        Email <span class="text-red-500">*</span>
      </label>
      <p-iconField iconPosition="right">
        <p-inputIcon styleClass="pi pi-envelope text-500 pr-2" />
        <input
          id="forget-email"
          pInputText
          type="email"
          placeholder="name@company.com"
          class="w-full"
          formControlName="forget_email"
          [class.p-invalid]="
            forgetSubmitted && forgetEmailFormGroup.get('forget_email')?.invalid
          "
        />
      </p-iconField>
    </div>

    <div
      *ngIf="forgetSubmitted && forgetEmailFormGroup.invalid"
      class="signup-error-banner flex align-items-center gap-2 p-3 border-round text-sm"
    >
      <i
        class="pi pi-exclamation-circle text-base text-red-600 flex-shrink-0"
      ></i>
      <span class="text-red-700 font-medium">
        Please enter a valid email address.
      </span>
    </div>

    <div
      class="flex justify-content-end align-items-center gap-3 mt-3 pt-3 border-top-1 surface-border"
    >
      <p-button
        type="button"
        label="Cancel"
        [disabled]="isResettingPassword"
        (onClick)="closeForgotPassword()"
        styleClass="signup-cancel-btn"
      />
      <p-button
        type="submit"
        label="Reset password"
        icon="pi pi-arrow-right"
        iconPos="right"
        [loading]="isResettingPassword"
        styleClass="signup-submit-btn"
      />
    </div>
  </form>
</p-dialog>

<p-dialog
  [draggable]="false"
  [modal]="true"
  [(visible)]="popupSignUp"
  [closable]="!isSigningUp"
  [closeOnEscape]="!isSigningUp"
  [style]="{ width: '540px', maxWidth: 'calc(100vw - 2rem)' }"
  styleClass="signup-dialog"
  (onHide)="onSignUpHide()"
>
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-3">
      <div
        class="signup-header-icon flex align-items-center justify-content-center"
      >
        <i class="pi pi-user-plus text-primary text-xl"></i>
      </div>
      <div>
        <h2 class="text-xl font-bold text-900 m-0 line-height-2">
          Account Sign Up
        </h2>
        <p class="text-lg text-500 m-0 mt-1">
          Please enter your information to create an account
        </p>
      </div>
    </div>
  </ng-template>

  <form
    class="flex flex-column gap-3 pt-2"
    [formGroup]="signUpFormGroup"
    (ngSubmit)="signUp()"
    autocomplete="off"
  >
    <div class="signup-name-fields">
      <div class="flex flex-column gap-2">
        <label for="signup-first-name" class="signup-label"
          >First name <span class="text-red-500">*</span></label
        >
        <input
          id="signup-first-name"
          pInputText
          placeholder="First name"
          class="w-full"
          formControlName="user_first_name"
          [class.p-invalid]="
            signUpSubmitted && signUpFormGroup.get('user_first_name')?.invalid
          "
        />
      </div>
      <div class="flex flex-column gap-2">
        <label for="signup-last-name" class="signup-label"
          >Last name <span class="text-red-500">*</span></label
        >
        <input
          id="signup-last-name"
          pInputText
          placeholder="Last name"
          class="w-full"
          formControlName="user_last_name"
          [class.p-invalid]="
            signUpSubmitted && signUpFormGroup.get('user_last_name')?.invalid
          "
        />
      </div>
    </div>

    <div class="flex flex-column gap-2">
      <label for="signup-email" class="signup-label"
        >Email <span class="text-red-500">*</span></label
      >
      <p-iconField iconPosition="right">
        <p-inputIcon styleClass="pi pi-envelope text-500 pr-2" />
        <input
          id="signup-email"
          pInputText
          type="email"
          placeholder="name@company.com"
          class="w-full"
          formControlName="user_email"
          [class.p-invalid]="
            signUpSubmitted && signUpFormGroup.get('user_email')?.invalid
          "
        />
      </p-iconField>
    </div>

    <div class="flex flex-column gap-2">
      <label for="signup-password" class="signup-label"
        >Password <span class="text-red-500">*</span></label
      >
      <p-iconField iconPosition="right">
        <a
          class="pointer"
          *ngIf="!showSignUpPass"
          (click)="showSignUpPass = !showSignUpPass"
          tabindex="0"
          (keydown.enter)="showSignUpPass = !showSignUpPass"
        >
          <p-inputIcon styleClass="pi pi-eye cursor-pointer text-500 pr-2" />
        </a>
        <a
          class="pointer"
          *ngIf="showSignUpPass"
          (click)="showSignUpPass = !showSignUpPass"
          tabindex="0"
          (keydown.enter)="showSignUpPass = !showSignUpPass"
        >
          <p-inputIcon
            styleClass="pi pi-eye-slash cursor-pointer text-500 pr-2"
          />
        </a>
        <input
          id="signup-password"
          pInputText
          type="{{ !showSignUpPass ? 'password' : 'text' }}"
          placeholder="Password (minimum 6 characters)"
          class="w-full"
          formControlName="user_password"
          autocomplete="new-password"
          [class.p-invalid]="
            signUpSubmitted && signUpFormGroup.get('user_password')?.invalid
          "
        />
      </p-iconField>
    </div>

    <div class="flex flex-column gap-2">
      <label for="signup-cellphone" class="signup-label"
        >Cell Phone <span class="text-red-500">*</span></label
      >
      <p-iconField iconPosition="right">
        <p-inputIcon styleClass="pi pi-phone text-500 pr-2" />
        <input
          id="signup-cellphone"
          pInputText
          placeholder="Phone number"
          class="w-full"
          formControlName="cellphone"
          [class.p-invalid]="
            signUpSubmitted && signUpFormGroup.get('cellphone')?.invalid
          "
        />
      </p-iconField>
    </div>

    <div class="flex flex-column gap-2">
      <label for="signup-default-location" class="signup-label"
        >Default Location <span class="text-red-500">*</span></label
      >
      <p-dropdown
        inputId="signup-default-location"
        [options]="$locationList()"
        formControlName="default_location_id"
        optionLabel="location_name"
        optionValue="location_id"
        placeholder="Select a default location"
        styleClass="w-full"
        appendTo="body"
        [loading]="isLoadingLocations"
        [filter]="true"
        filterBy="location_name,location_number"
        [class.p-invalid]="
          signUpSubmitted && signUpFormGroup.get('default_location_id')?.invalid
        "
      >
        <ng-template let-location pTemplate="item">
          <div
            class="flex align-items-center justify-content-between w-full py-1"
          >
            <span>{{ location.location_name }}</span>
            <span
              *ngIf="location.location_number"
              class="text-600 ml-2 font-medium"
            >
              (#{{ location.location_number }})
            </span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <div
      *ngIf="signUpSubmitted && signUpFormGroup.invalid"
      class="signup-error-banner flex align-items-center gap-2 p-3 border-round text-sm"
    >
      <i
        class="pi pi-exclamation-circle text-base text-red-600 flex-shrink-0"
      ></i>
      <span class="text-red-700 font-medium">
        Please complete all required fields with valid information.
      </span>
    </div>

    <div
      class="flex justify-content-end align-items-center gap-3 mt-3 pt-3 border-top-1 surface-border"
    >
      <p-button
        type="button"
        label="Cancel"
        [disabled]="isSigningUp"
        (onClick)="closeSignUp()"
        styleClass="signup-cancel-btn"
      />
      <p-button
        type="submit"
        label="Create account"
        icon="pi pi-arrow-right"
        iconPos="right"
        [loading]="isSigningUp"
        styleClass="signup-submit-btn"
      />
    </div>
  </form>
</p-dialog>

<p-toast />
